import { render, staticRenderFns } from "./Step4.vue?vue&type=template&id=377ca9e8&scoped=true&"
import script from "./Step4.vue?vue&type=script&lang=ts&"
export * from "./Step4.vue?vue&type=script&lang=ts&"
import style0 from "./Step4.vue?vue&type=style&index=0&id=377ca9e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377ca9e8",
  null
  
)

export default component.exports